export const BASE_THEME = {
  transparent: 'rgba(0, 0, 0, 0)',
  secondaryText: '#8C8D94',
  primaryTextV1: '#000F1D',
  secondaryTextV1: '#001325',
  red: '#ff0000',
  redLight: '#fadfd6',
  green: '#5cd285',
  aquaGreen: '#4db6ac',
  lightGreen: '#93e026',
  lightgreen: '#24f285',
  lightGreyShadow: '#00132528',
  darkGreen: '#378b37',
  yellow: '#fea838',
  brown: '#5D4037',
  black: '#000',
  white: '#fff',
  blue: {
    B1: 'rgba(234, 246, 255, 0.38)',
    B2: '#00aeef',
    B3: '#0000FF',
    B4: '#4a7ba1',
    B5: '#1c5078',
  },
  grey: {
    G1: '#ebebeb',
    G2: '#e1e1e1',
    G3: '#cdcdcd',
    G4: '#b6b6b6',
    G5: '#979797',
    G6: '#8c8d94',
    G7: '#7b7b7b',
    G8: '#6d6a6a',
    G9: '#404040',
    G10: '#657786',
  },
  whiteOpacity: {
    O5: 'rgba(255, 255, 255, 0.5)',
    O8: 'rgba(255, 255, 255, 0.8)',
  },
  blackOpacity: {
    O1: 'rgba(0, 0, 0, 0.1)',
    O2: 'rgba(0, 0, 0, 0.2)',
    O3: 'rgba(0, 0, 0, 0.3)',
    O5: 'rgba(0, 0, 0, 0.5)',
    O6: 'rgba(0, 0, 0, 0.6)',
    O7: 'rgba(0, 0, 0, 0.7)',
  },

  warn : {
    bg: '#fdf5eb',
    border: '#f8e1c5',
  },

  error : {
    bg: '#f6e0e0',
    border: '#ebbbbb',
  },

  info : {
    bg: '#e0edff',
    border: '#c6deff',
  },
  success : {
    bg: '#ebf6f1',
    border: '#c5e4d5',
  },
  tagBorder: 'rgba(0, 109, 255, 0.16)',
  tagBg: '#ebf4ff'
};

export const NYKAA_BASE_THEME = {
  colors: {
    lightCityBackground: "#FFF5FB",
    btnOutlineBorder: "#cdcdcd",
    overlayLayoutBg: "rgba(17, 19, 20, 0.5)",
    discountStripBg: "#ecf9ee",
    paymentMethodTitleBorder: "rgba(0, 19, 37, 0.16)",
    messageCardInfoFill: "rgba(56, 141, 255, 0.08)",
    messageCardInfoBorder: "rgba(56, 141, 255, 0.16)",
    bagTableColor: "#001325",
    borderTertiary: "rgba(0, 19, 37, 0.08)",
    placeholderColor: "rgba(0, 19, 37, 0.36)",
    deliverToAddressColor: "#001325",
    titleColor: "rgba(0, 19, 37, 0.92)",
    bankNameColor: "rgba(0, 19, 37, 0.64)",
    addressDefaultLabelColor: "#1C7DFF",
    selectedAddressCardBg: "rgba(232, 0, 113, 0.04)",
    addressPhoneColor: "rgba(0, 19, 37, 0.64)",
    toggleSwitchBorderColor: "#00132528",
    toggleSwitchOffBg: "#CCCCCC",
    toggleSwitchOnBg: "#E80071",
    addAddressCardHoverBg: "rgba(232, 0, 113, 0.08)",
    addressCardHoverBg: "#f9fafa",
    btnContainedDisabledColor: "rgba(0, 19, 37, 0.64)",
    textPrimary064: "rgba(0, 19, 37, 0.64)",
    inputDisabledColor: "#001325",
    secondaryTextGrey: "#001325A3",
    ocpBottomBannerBg: "#FFEFF1",
    ocpBottomBannerColor: "#001325",
    ocpEddColor: "#008945",
    disableBankColor: "#111111",
    dWebModalContent: "#707072",
  },
  borders: {
    orderConfirmationSectionBorder: "none",
    desktopSelectedPaymentMethodBorderHeight: "44px",
    desktopSelectedPaymentMethodBorderRadius: "8px",
    messageCardBorderRadius: "16px",
    dropdownBorderStyle: "2px solid",
    addressCardBorder: "none",
    addAddressCardBorder: "1px dashed rgba(0, 19, 37, 0.16)",
    dWebAddressCardBorder: "1px solid rgba(0, 19, 37, 0.16)",
    btnOutlineBorderColor: "rgba(111, 121, 129, 0.36)",
    bagDetailsBorderRadius: "8px 8px 0 0",
    priceDetailsBorderRadius: "0 0 8px 8px",
    ocpBottomBannerBorder: "1px solid rgba(0, 19, 37, 0.08)",
    buyAssuranceBorder: "none",
  },
  typography: {
    secondaryText : {
      lineHeight: "12px",
      fontFamily: "Inter",
      fontSize: "8px",
      fontStyle: "normal",
      fontWeight: 600
    },
    bodyXlarge:{
      lineHeight: "24px",
      fontFamily: "Inter",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 400
    },
    titleSM: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    subTitleLG: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    bodyLG: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    eddText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    orderConfirmationTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    orderConfirmationSubTitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    button: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "14px",
    },
    offerSubtitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: 0,
    },
    messageCardText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: 600,
      letterSpacing: 0,
    },
    addressName: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressLine: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressSectionTitle: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    addressHeaderSubtitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemSubtitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    cartQuantityTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartPriceTitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
    },
    paymentMethodAlert: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    priceDetailAmount: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    bankListName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpSectionTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    ocpAddressName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpHelpTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    ocpProductName: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpProductPrice: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpProductEdd: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpHelpButtonTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpHelpButtonSubtitle: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    dWebModalTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    dWebModalContent: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    updateDetailsText: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  },
};

export const MEN_BASE_THEME = {
  colors: {
    primary: '#003243',
    secondaryInverse:'#62A3C4',
    lightCityBackground: "#F4FBFF",
    btnOutlineBorder: "#cdcdcd",
    overlayLayoutBg: "rgba(17, 19, 20, 0.5)",
    discountStripBg: "#ecf9ee",
    paymentMethodTitleBorder: "rgba(0, 19, 37, 0.16)",
    messageCardInfoFill: "rgba(56, 141, 255, 0.08)",
    messageCardInfoBorder: "rgba(56, 141, 255, 0.16)",
    bagTableColor: "#001325",
    borderTertiary: "rgba(0, 19, 37, 0.08)",
    placeholderColor: "rgba(0, 19, 37, 0.36)",
    deliverToAddressColor: "#001325",
    titleColor: "rgba(0, 19, 37, 0.92)",
    bankNameColor: "rgba(0, 19, 37, 0.64)",
    addressDefaultLabelColor: "#1C7DFF",
    selectedAddressCardBg: "rgba(0, 50, 67, 0.04)",
    addressPhoneColor: "rgba(0, 19, 37, 0.64)",
    toggleSwitchBorderColor: "#00132528",
    toggleSwitchOffBg: "#CCCCCC",
    toggleSwitchOnBg: "#003243",
    addAddressCardHoverBg: "rgba(0, 50, 67, 0.08)",
    addressCardHoverBg: "#f9fafa",
    btnContainedDisabledColor: "rgba(0, 19, 37, 0.64)",
    textPrimary064: "rgba(0, 19, 37, 0.64)",
    inputDisabledColor: "#001325",
    secondaryTextGrey: "#001325A3",
    ocpBottomBannerBg: "#FFEFF1",
    ocpBottomBannerColor: "#001325",
    ocpEddColor: "#008945",
    disableBankColor: "#9E9EA0",
    dWebModalContent: "#707072",
  },
  borders: {
    orderConfirmationSectionBorder: "none",
    desktopSelectedPaymentMethodBorderHeight: "44px",
    desktopSelectedPaymentMethodBorderRadius: "8px",
    messageCardBorderRadius: "16px",
    dropdownBorderStyle: "2px solid",
    addressCardBorder: "none",
    addAddressCardBorder: "1px dashed rgba(0, 19, 37, 0.16)",
    dWebAddressCardBorder: "1px solid rgba(0, 19, 37, 0.16)",
    btnOutlineBorderColor: "rgba(111, 121, 129, 0.36)",
    bagDetailsBorderRadius: "8px 8px 0 0",
    priceDetailsBorderRadius: "0 0 8px 8px",
    ocpBottomBannerBorder: "1px solid rgba(0, 19, 37, 0.08)",
    buyAssuranceBorder: "none",
  },
  typography: {
    secondaryText : {
      lineHeight: "12px",
      fontFamily: "Inter",
      fontSize: "8px",
      fontStyle: "normal",
      fontWeight: 600
    },
    bodyXlarge:{
      lineHeight: "24px",
      fontFamily: "Inter",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 400
    },
    titleSM: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    subTitleLG: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    bodyLG: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    eddText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    orderConfirmationTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    orderConfirmationSubTitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    button: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "14px",
    },
    offerSubtitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: 0,
    },
    messageCardText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: 600,
      letterSpacing: 0,
    },
    addressName: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressLine: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressSectionTitle: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    addressHeaderSubtitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemSubtitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    cartQuantityTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartPriceTitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
    },
    paymentMethodAlert: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    priceDetailAmount: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    bankListName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpSectionTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    ocpAddressName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpHelpTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    ocpProductName: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpProductPrice: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpProductEdd: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpHelpButtonTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpHelpButtonSubtitle: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    dWebModalTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    dWebModalContent: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    updateDetailsText: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  },
};

export const FASHION_BASE_THEME = {
  colors: {
    primary: '#001325',
    buttonPrimaryFill:'#001325',
    brandPrimary: '#001325',
    brandSecondary: '#001325',
    linkTextColor: '#fd7685',
    lightCityBackground: "#FFF8F9",
    btnOutlineBorder: "#cdcdcd",
    overlayLayoutBg: "rgba(17, 19, 20, 0.5)",
    discountStripBg: "#ecf9ee",
    paymentMethodTitleBorder: "rgba(0, 19, 37, 0.16)",
    messageCardInfoFill: "rgba(56, 141, 255, 0.08)",
    messageCardInfoBorder: "rgba(56, 141, 255, 0.16)",
    bagTableColor: "#001325",
    borderTertiary: "rgba(0, 19, 37, 0.08)",
    placeholderColor: "rgba(0, 19, 37, 0.36)",
    deliverToAddressColor: "#001325",
    titleColor: "rgba(0, 19, 37, 0.92)",
    bankNameColor: "rgba(0, 19, 37, 0.64)",
    addressDefaultLabelColor: "#1C7DFF",
    selectedAddressCardBg: "rgba(253, 118, 134, 0.04)",
    addressPhoneColor: "rgba(0, 19, 37, 0.64)",
    toggleSwitchBorderColor: "#00132528",
    toggleSwitchOffBg: "#CCCCCC",
    toggleSwitchOnBg: "#FD7685",
    addAddressCardHoverBg: "rgba(0, 19, 37, 0.08)",
    addressCardHoverBg: "#f9fafa",
    btnContainedDisabledColor: "rgba(0, 19, 37, 0.64)",
    textPrimary064: "rgba(0, 19, 37, 0.64)",
    inputDisabledColor: "#001325",
    secondaryTextGrey: "#001325A3",
    ocpBottomBannerBg: "#FFEFF1",
    ocpBottomBannerColor: "#001325",
    ocpEddColor: "#008945",
    disableBankColor: "#9E9EA0",
    dWebModalContent: "#707072",
  },
  borders:{
    radius30 :"2px",
    radiusPrimary: "2px",
    orderConfirmationSectionBorder: "none",
    desktopSelectedPaymentMethodBorderHeight: "44px",
    desktopSelectedPaymentMethodBorderRadius: "8px",
    messageCardBorderRadius: "16px",
    dropdownBorderStyle: "2px solid",
    addressCardBorder: "none",
    addAddressCardBorder: "1px dashed rgba(0, 19, 37, 0.16)",
    dWebAddressCardBorder: "1px solid rgba(0, 19, 37, 0.16)",
    btnOutlineBorderColor: "rgba(111, 121, 129, 0.36)",
    bagDetailsBorderRadius: "0 0 0 0",
    priceDetailsBorderRadius: "0 0 0 0",
    ocpBottomBannerBorder: "1px solid rgba(0, 19, 37, 0.08)",
    buyAssuranceBorder: "none",
  },
  typography: {
    secondaryText : {
      lineHeight: "12px",
      fontFamily: "Inter",
      fontSize: "8px",
      fontStyle: "normal",
      fontWeight: 600
    },
    bodyXlarge:{
      lineHeight: "24px",
      fontFamily: "Inter",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 400
    },
    titleSM: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    subTitleLG: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    bodyLG: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    eddText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    orderConfirmationTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    orderConfirmationSubTitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    button: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "14px",
    },
    offerSubtitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: 0,
    },
    messageCardText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: 600,
      letterSpacing: 0,
    },
    addressName: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressLine: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressSectionTitle: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    addressHeaderSubtitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemSubtitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    cartQuantityTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartPriceTitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
    },
    paymentMethodAlert: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    priceDetailAmount: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    bankListName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpSectionTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    ocpAddressName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpHelpTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    ocpProductName: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpProductPrice: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpProductEdd: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpHelpButtonTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpHelpButtonSubtitle: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    dWebModalTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    dWebModalContent: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    updateDetailsText: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  },
};

export const FOOTLOCKER_BASE_THEME = {
  colors: {
    primary: '#20272D',
    primary10: '#757575',
    secondary: '#20272D',
    secondary10: '#F9FAFA',
    info10: '#E5EE57',
    textPrimary: '#20272D',
    textDisabled: '#6D7780',
    buttonPrimaryFill:'#001325',
    brandPrimary: '#001325',
    brandSecondary: '#001325',
    linkTextColor: '#fd7685',
    pink500: '#20272D',
    btnOutlineBorder: "#cdcdcd",
    overlayLayoutBg: "rgba(17, 19, 20, 0.5)",
    discountStripBg: "#ecf9ee",
    paymentMethodTitleBorder: "rgba(0, 19, 37, 0.16)",
    messageCardInfoFill: "rgba(56, 141, 255, 0.08)",
    messageCardInfoBorder: "rgba(56, 141, 255, 0.16)",
    bagTableColor: "#20272D",
    borderTertiary: "rgba(0, 19, 37, 0.08)",
    placeholderColor: "rgba(0, 19, 37, 0.36)",
    deliverToAddressColor: "#20272D",
    titleColor: "rgba(0, 19, 37, 0.92)",
    bankNameColor: "rgba(0, 19, 37, 0.64)",
    addressDefaultLabelColor: "#1C7DFF",
    selectedAddressCardBg: "rgba(32, 39, 45, 0.04)",
    addressPhoneColor: "rgba(0, 19, 37, 0.64)",
    toggleSwitchBorderColor: "#00132528",
    toggleSwitchOffBg: "#CCCCCC",
    toggleSwitchOnBg: "#20272D",
    addAddressCardHoverBg: "rgba(32, 39, 45, 0.08)",
    addressCardHoverBg: "#f9fafa",
    btnContainedDisabledColor: "rgba(32, 39, 45, 0.64)",
    textPrimary064: "rgba(32, 39, 45, 0.64)",
    inputDisabledColor: "#20272D",
    secondaryTextGrey: "#001325A3",
    ocpBottomBannerBg: "#FFEFF1",
    ocpBottomBannerColor: "#20272D",
    ocpEddColor: "#008945",
    disableBankColor: "#9E9EA0",
    dWebModalContent: "#707072",
  },
  borders:{
    radius30 :"2px",
    radiusPrimary: "2px",
    pink500: '#20272D', // for reward details in price details
    orderConfirmationSectionBorder: "none",
    desktopSelectedPaymentMethodBorderHeight: "44px",
    desktopSelectedPaymentMethodBorderRadius: "8px",
    messageCardBorderRadius: "16px",
    dropdownBorderStyle: "2px solid",
    addressCardBorder: "none",
    addAddressCardBorder: "1px dashed rgba(0, 19, 37, 0.16)",
    dWebAddressCardBorder: "1px solid rgba(32, 39, 45, 0.16)",
    btnOutlineBorderColor: "rgba(111, 121, 129, 0.36)",
    bagDetailsBorderRadius: "0 0 0 0",
    priceDetailsBorderRadius: "0 0 0 0",
    ocpBottomBannerBorder: "1px solid rgba(0, 19, 37, 0.08)",
    buyAssuranceBorder: "none",
  },
  brandtextPrimaryColor:'#20272D',
  brandPrimaryOpacity: {
    backgroundColor: '#20272D' // for address card
  },
  typography: {
    secondaryText : {
      lineHeight: "12px",
      fontFamily: "Inter",
      fontSize: "8px",
      fontStyle: "normal",
      fontWeight: 600
    },
    bodyXlarge:{
      lineHeight: "24px",
      fontFamily: "Inter",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 400
    },
    titleSM: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    subTitleLG: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    bodyLG: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    eddText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    orderConfirmationTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: -0.1,
    },
    orderConfirmationSubTitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    button: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "14px",
    },
    offerSubtitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: 0,
    },
    messageCardText: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: 600,
      letterSpacing: 0,
    },
    addressName: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressLine: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    addressSectionTitle: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    addressHeaderSubtitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartItemSubtitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    cartQuantityTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    cartPriceTitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
    },
    paymentMethodAlert: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    priceDetailAmount: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    bankListName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpSectionTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: 0,
    },
    ocpAddressName: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    ocpHelpTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    ocpProductName: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpProductPrice: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpProductEdd: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    ocpHelpButtonTitle: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    ocpHelpButtonSubtitle: {
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "12px",
      letterSpacing: 0.1,
    },
    dWebModalTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    dWebModalContent: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    updateDetailsText: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  },
};

export const NIKE_BASE_THEME = {
  colors: {
    primary: "#111111",
    primary10: "#111111",
    secondary: "#F5F5F5",
    secondary10: "#E8E8E8",
    messageCardInfoFill: "#F3F4F5",
    messageCardInfoBorder: "transparent",
    info10: "#B9E2FF",
    textPrimary: "#111111",
    textDisabled: "#CACACB",
    buttonPrimaryFill:"#111111",
    brandPrimary: "#111111",
    brandSecondary: "#001325",
    linkTextColor: "#111111",
    pink500: "#20272D",
    inputBg: "#ffffff",
    inputErrorBg: "#ffffff",
    negative: "#D30005",
    discountStripBg: "#ffffff",
    offerWidgetBg: "#ffffff",
    offerWidgetBorder: "#E5E5E5",
    btnOutlineBorder: "#707072",
    overlayLayoutBg: "rgba(17, 19, 20, 0.64)",
    paymentMethodTitleBorder: "transparent",
    textSecondary: "#707072",
    bagTableColor: "#707072",
    borderTertiary: "#E5E5E5",
    placeholderColor: "transparent",
    deliverToAddressColor: "#707072",
    titleColor: "#111111",
    bankNameColor: "#111111",
    addressDefaultLabelColor: "#707072",
    selectedAddressCardBg: "transparent",
    addressPhoneColor: "#707072",
    toggleSwitchBorderColor: "transparent",
    toggleSwitchOffBg: "#E5E5E5",
    toggleSwitchOnBg: "#007D48",
    addAddressCardHoverBg: "#F5F5F5",
    addressCardHoverBg: "#F5F5F5",
    btnContainedDisabledColor: "#111111",
    textPrimary064: "#707072",
    inputDisabledColor: "#707072",
    inputDisabledLabelColor: "#9E9EA0",
    secondaryTextGrey: "#111111",
    ocpBottomBannerBg: "#F5F5F5",
    ocpBottomBannerColor: "#707072",
    ocpEddColor: "#111111",
    positive: "#007D48",
    disableBankColor: "#9E9EA0",
    info: "#1151FF",
    blue500: "#1151FF",
    notificationInfoBorderColor: "#1151FF",
    notificationInfoFill: "#1151FF",
    dWebModalContent: "#707072",
    snow200: "#f5f5f5",
  },
  borders:{
    radius30 : "30px",
    radiusPrimary: "16px",
    pink500: "#20272D", // for reward details in price details
    inputBorder: "1px solid #707072",
    inputRadius: "8px",
    inputFocusBorder: "1px solid #111111",
    inputErrorBorder: "1px solid #D30005",
    wrapperBorderRadius: "16px",
    offerWidgetBorderRadius: "16px",
    orderConfirmationSectionBorder: "1px solid #E5E5E5",
    notificationInfoBorder: "",
    desktopSelectedPaymentMethodBorderHeight: "80px",
    desktopSelectedPaymentMethodBorderRadius: "0",
    messageCardBorderRadius: "8px",
    dropdownBorderStyle: "none",
    addressCardBorder: "1px solid #E5E5E5",
    addAddressCardBorder: "1px dashed #E5E5E5",
    dWebAddressCardBorder: "1px solid #E5E5E5",
    btnOutlineBorderColor: "#707072",
    bagDetailsBorderRadius: "16px 16px 0 0",
    priceDetailsBorderRadius: "0 0 16px 16px",
    desktopPaymentChildLayoutRadius: "0",
    inputDisabledBorderColor: "#CACACB",
    ocpBottomBannerBorder: "none",
    buyAssuranceBorder: "1px solid #E5E5E5",
  },
  brandtextPrimaryColor: "#20272D",
  brandPrimaryOpacity: {
    backgroundColor: "#20272D", // for address card
  },
  typography: {
    inputLabel: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    inputFocusLabel: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    titleLarge: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "28px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    titleSmall: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
    },
    titleSM: {
      fontFamily: "'Helvetica Now Text', sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    eddText: {
      fontFamily: "'Helvetica Now Text', sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "21px",
    },
    subTitleLG: {
      fontFamily: "'Helvetica Now Text', sans-serif",
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    bodyLG: {
      fontFamily: "'Helvetica Now Text', sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    orderConfirmationTitle: {
      fontSize: "32px",
      fontWeight: 400,
      lineHeight: "38px",
      fontFamily: "'Helvetica Now Text', sans-serif",
    },
    orderConfirmationSubTitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "28px",
      letterSpacing: 0,
    },
    button: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
      "-webkit-font-smoothing": "antialiased",
    },
    buttonSmall: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
      "-webkit-font-smoothing": "antialiased",
    },
    buttonMedium: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
      "-webkit-font-smoothing": "antialiased",
    },
    buttonLarge: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
      "-webkit-font-smoothing": "antialiased",
    },
    offerSubtitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: 0,
    },
    messageCardText: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: 0,
    },
    type362: {
      fontSize: "40px",
      lineHeight: "48px",
      fontWeight: 500,
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type200: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    titleMedium: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type201: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type202: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type240: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "28px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type241: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "28px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type242: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "28px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type320: {
      fontSize: "32px",
      fontWeight: 500,
      lineHeight: "36px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type321: {
      fontSize: "32px",
      fontWeight: 500,
      lineHeight: "36px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    type322: {
      fontSize: "32px",
      fontWeight: 500,
      lineHeight: "36px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    headerTitle: {
      fontSize: "16px",
      fontWeight: 500,
      letterSpacing: 0,
    },
    type120: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    type121: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "21px",
    },
    type122: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "21px",
    },
    subTitleSmall: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "21px",
      letterSpacing: 0,
    },
    bodySmall: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: 0,
    },
    labelMedium: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: 0.6,
    },
    labelSmall: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
    },
    addressName: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    addressLine: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    addressSectionTitle: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "28px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    addressHeaderSubtitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    cartItemTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    cartItemSubtitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    cartQuantityTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    cartPriceTitle: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    paymentMethodAlert: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    priceDetailAmount: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    bankListName: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    ocpSectionTitle: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
      "-webkit-font-smoothing": "auto",
    },
    ocpAddressName: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    ocpItemTitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    ocpHelpTitle: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Display', sans-serif",
      "-webkit-font-smoothing": "auto",
    },
    ocpProductName: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
    },
    ocpProductPrice: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "18px",
    },
    ocpProductEdd: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "21px",
    },
    ocpHelpButtonTitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      fontFamily: "'Helvetica Now Text', sans-serif",
    },
    ocpHelpButtonSubtitle: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
      fontFamily: "'Helvetica Now Text', sans-serif",
    },
    dWebModalTitle: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "29px",
      fontFamily: "'Helvetica Now Display', sans-serif",
    },
    dWebModalContent: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    updateDetailsText: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  },
};
